import * as posedetection from "@tensorflow-models/pose-detection";
import {GameBase} from "./GameBase";
import {Point} from "../Point";
import {AudioInput} from "../common/AudioInput";
import {Fukidashi} from "../common/Fukidashi";
import {RenderUtil} from "../common/RenderUtil";
import {SoundEffect} from "../common/SoundEffect";

const mainColor = '#1199ff'
const PHASE = {
  // START: 1,
  WAIT_KA: 2,
  KA: 3,
  WAIT_ME1: 4,
  ME1: 5,
  WAIT_HA1: 6,
  HA1: 7,
  WAIT_ME2: 8,
  ME2: 9,
  WAIT_SHOOT: 10,
  SHOOT: 11,
  COOL_DOWN: 12,
}
const DEFAULT_Z = 0.3
const CHARGE_BULLET_SIZE = 30
const CHARGE_MAX = 45
const CHARGE_MAX2 = 240
// const CHARGE_MAX2 = 1
const COOL_DOWN_TIME = 60
const PHASE_CONF = {
  [PHASE.KA]: { text: "か", size: 10 },
  [PHASE.ME1]: { text: "め", size: 20 },
  [PHASE.HA1]: { text: "は", size: 30 },
  [PHASE.ME2]: { text: "め", size: 50 },
  [PHASE.SHOOT]: { text: "波!"},
}
export class Kamehameha extends GameBase {
  constructor(settings) {
    super();

    this.power = 0
    this.bulletPos = { x: 0, y: 0, z: DEFAULT_Z }
    this.vec = { x: 0, y: 5, z: 0 }
    this.poseMode = posedetection.SupportedModels.BlazePose
    this.handMode = false
    // this.handMode = true
    this.phase = PHASE.WAIT_KA
    this.debug = ""
    this.fukidashi = new Fukidashi()
    this.mousePos = null

    this.audioInput = new AudioInput()
    this.rot = 0
    this.rotSpeed = 0

    this.volumeThreshold = settings.find(s => s.key === 'volumeThreshold')['default']
    this.handShowThreshold = 0.1
    this.handDistThreshold = 0.25

    this.soundEffect = new SoundEffect('shoot')

    this.lastLoop = null
    window.addEventListener("keydown", (event) => { this.handleKeydown(event) });
  }

  handleKeydown(event){
    if (event.code === 'KeyZ') {
      this.shoot()
    }
    if (event.code === 'KeyX') {
      this.reset()
    }
  }

  mainLoop({ pose, hands }) {
    // console.log('main', this.audioInput.volume)
    if (pose && pose[0]) {
      const p2d = pose[0].keypoints
      const p3d = pose[0].keypoints3D

      const navigations = []
      if (p2d[16].score < this.handShowThreshold) {
        navigations.push({icon: 'warning', text: "右手が映る位置"})
      }
      if (p2d[15].score < this.handShowThreshold) {
        navigations.push({icon: 'warning', text: "左手が映る位置"})
      }
      if (Point.dist(p3d[16], p3d[15]) > this.handDistThreshold) {
        navigations.push({icon: 'warning', text: "両手の距離"})
      }
      this.navigations = navigations
      if (navigations.length > 0) {
        return
      }
    }

    const now = new Date().getTime()
    if (!this.lastLoop) {
      this.lastLoop = now
    }
    let diff = Math.round((now - this.lastLoop)/16)
    // console.log(diff)
    if (diff > 0) {
      this.lastLoop = now
    }
    diff = 1

    this.right = hands.find(h => h.handedness === "Left")
    switch (this.phase) {
      case PHASE.WAIT_KA:
      case PHASE.WAIT_ME1:
      case PHASE.WAIT_HA1:
      case PHASE.WAIT_ME2:
      case PHASE.WAIT_SHOOT:
        if (this.audioInput.volume > this.volumeThreshold) {
          this.phase++

          if (this.phase === PHASE.SHOOT) {
            this.soundEffect.play()
          }
        }
        break

      case PHASE.KA:
      case PHASE.ME1:
      case PHASE.HA1:
      case PHASE.ME2:
        this.power+=diff
        if (this.power > CHARGE_MAX) {
          this.phase++
          this.power = 0
        }
        break
      case PHASE.SHOOT:
        this.power+=diff
        if (this.power > CHARGE_MAX2) {
          this.phase = PHASE.COOL_DOWN
          this.power = 0
        }
        break
      case PHASE.COOL_DOWN:
        this.power+=diff
        if (this.power > COOL_DOWN_TIME) {
          this.phase = PHASE.WAIT_KA
          this.power = 0
          // this.stopRecord()
        }
        break
    }

    if (pose && pose[0]) {
      const p2d = pose[0].keypoints

      this.mousePos = { x: -p2d[7].x + 240, y:p2d[7].y - 120 }

      let r1 = new Point(p2d[16])
      let r2 = r1.add(new Point(p2d[16]).delta(p2d[14]).multiply(15))
      let l1 = new Point(p2d[15])
      let l2 = r1.add(new Point(p2d[15]).delta(p2d[13]).multiply(15))

      let tc = (r1.x-r2.x)*(l1.y-r1.y)+(r1.y-r2.y)*(r1.x-l1.x)
      let td = (r1.x-r2.x)*(l2.y-r1.y)+(r1.y-r2.y)*(r1.x-l2.x)
      if (tc * td < 0) {
        let t = l2
        l2 = r2
        r2 = t
      }

      r1 = r1.add(r2.delta(r1).multiply(0.05))
      l1 = l1.add(l2.delta(r1).multiply(0.05))
      this.rect = { r1, l1, r2, l2, c: r1.add(l1.delta(r1).multiply(0.5)) }
    }
  }

  renderCamera(ctx, { pose, hands }) {
    if (this.navigations.length > 0) {
      return
    }
    this.ctx = ctx

    if (!this.rect) return


    this.ctx.save();
    this.ctx.scale(-1, 1);


    switch (this.phase) {
      case PHASE.WAIT_KA:
        break
      case PHASE.WAIT_ME1:
      case PHASE.WAIT_HA1:
      case PHASE.WAIT_ME2:
      case PHASE.WAIT_SHOOT:
        this.fukidashi.draw(this.ctx, this.mousePos, 78, PHASE_CONF[this.phase - 1].text)
        // this.ctx.font = `${78}px 'Noto Sans JP', sans-serif`
        // this.ctx.fillText(PHASE_CONF[this.phase - 1].text, -300, 100);
        break

      case PHASE.KA:
      case PHASE.ME1:
      case PHASE.HA1:
      case PHASE.ME2:
        this.fukidashi.draw(this.ctx, this.mousePos, 48+CHARGE_BULLET_SIZE*(this.power/CHARGE_MAX), PHASE_CONF[this.phase].text)
        break
      case PHASE.SHOOT:
        this.fukidashi.draw(this.ctx, this.mousePos, Math.min(100, 48+0.5*CHARGE_MAX2*(this.power/CHARGE_MAX2)), PHASE_CONF[this.phase].text)
        break
    }
    this.ctx.restore()

    ctx.lineCap = 'round'
    let ld = this.rect.r1.delta(this.rect.l1)
    let ld2 = this.rect.r2.delta(this.rect.l2)

    if (this.phase === PHASE.SHOOT) {
      this.ctx.lineWidth = 50
      const gradScale = 0.05
      for (let i = 0; i < 5; i++) {
        let r = i*50
        let g = i*15+175
        this.ctx.strokeStyle = `rgba(${r},${g},255,${0.5+i*0.1})`;
        this.drawLine(this.rect.r1.add(ld.multiply(-gradScale*i)), this.rect.r2.add(ld2.multiply(-gradScale*i)))
        this.drawLine(this.rect.l1.add(ld.multiply(gradScale*i)), this.rect.l2.add(ld2.multiply(gradScale*i)))
      }

      let tmp = this.ctx.globalCompositeOperation

      this.ctx.globalCompositeOperation = "lighter";
      this.ctx.strokeStyle = 'transparent';
      this.ctx.fillStyle = '#77aaff';
      this.drawRect(this.rect.r1, this.rect.r2, this.rect.l1, this.rect.l2)

      this.ctx.globalCompositeOperation = tmp

      this.drawCircle(
        this.rect.r2.add(this.rect.l2.delta(this.rect.r2).multiply(0.5)),
        Math.sqrt(
          (this.rect.r2.x - this.rect.l2.x) *
          (this.rect.r2.x - this.rect.l2.x) +
          (this.rect.r2.y - this.rect.l2.y) *
          (this.rect.r2.y - this.rect.l2.y)
        )
      )

      for (let i = 0; i < 10; i++) {
        const r1 = Math.random()*0.8+0.1
        const c1 = this.rect.r1.add(this.rect.l1.delta(this.rect.r1).multiply(r1))
        const c2 = this.rect.r2.add(this.rect.l2.delta(this.rect.r2).multiply(r1))
        this.ctx.lineWidth = 10
        this.ctx.lineCap = 'butt'
        this.ctx.strokeStyle = 'rgba(17,160,255,0.1)';
        this.drawLine(c1, c2)
      }
    }

    if (this.phase !== PHASE.WAIT_KA) {
      let bulletSize = 0
      if (PHASE_CONF[this.phase]) {
        bulletSize = PHASE_CONF[this.phase].size
      } else if (PHASE_CONF[this.phase - 1]) {
        bulletSize = PHASE_CONF[this.phase - 1].size
      }
      if (this.phase === PHASE.SHOOT || this.phase === PHASE.WAIT_SHOOT) {
        bulletSize = Math.sqrt(
          (this.rect.r1.x - this.rect.l1.x) *
          (this.rect.r1.x - this.rect.l1.x) +
          (this.rect.r1.y - this.rect.l1.y) *
          (this.rect.r1.y - this.rect.l1.y)
        )
      }

      this.drawCircle(this.rect.c, bulletSize)
    }

    if (this.phase === PHASE.WAIT_SHOOT || this.phase === PHASE.ME2) {
      let tmp = this.ctx.globalCompositeOperation
      this.ctx.globalCompositeOperation = "lighter"
      RenderUtil.drawHalos(this.ctx, this.rect.c, this.rot, mainColor)
      this.rotSpeed += 2
      this.rot += Math.sin(this.rotSpeed*Math.PI/180)*2.0+2.0
      this.ctx.globalCompositeOperation = tmp
    }
  }

  drawRect(r1, r2, l1, l2) {
    this.ctx.beginPath();
    this.ctx.moveTo(r1.x, r1.y);
    this.ctx.lineTo(l1.x, l1.y);
    this.ctx.lineTo(l2.x, l2.y);
    this.ctx.lineTo(r2.x, r2.y);
    this.ctx.lineTo(r1.x, r1.y);
    this.ctx.lineTo(l1.x, l1.y);
    this.ctx.stroke();
    this.ctx.fill();
  }

  drawLine(p1, p2) {
    this.ctx.beginPath();
    this.ctx.moveTo(p1.x, p1.y);
    this.ctx.lineTo(p2.x, p2.y);
    this.ctx.stroke();
  }

  drawCircle(pos, size) {
    let tmp = this.ctx.globalCompositeOperation
    this.ctx.globalCompositeOperation = "lighter";
    const rand = 20
    for (let i = 0; i < 8; i++) {
      size *= 0.9
      let r1 = Math.random() * rand - rand*0.5;
      let r2 = Math.random() * rand - rand*0.5;
      this.ctx.fillStyle = mainColor
      this.ctx.strokeStyle = this.ctx.fillStyle;
      this.ctx.beginPath();
      this.ctx.arc(pos.x + r1, pos.y + r2, size, 0, Math.PI * 2, true);
      this.ctx.stroke();
      this.ctx.fill();
    }

    this.ctx.globalCompositeOperation = tmp
  }
}



// WEBPACK FOOTER //
// ./src/components/game/Kamehameha.js